module.exports = {
	"articleTitle1": "Lab fire shuts down Chemistry building ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "lab",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/regents-approve-new-robotics-laboratory",
	"articleSnippet1": "Feb 8, 2017 ... The University of Michigan Chemistry building was evacuated and closed due to \na lab fire at approximately 9:30 a.m. Wednesday morning.",
	"articleSnippet2": "Sep 15, 2016 ... Thursday, the University of Michigan's Board of Regents approved an estimated \n$75 million new robotics laboratory, made possible through a ...",
	"foodRecommendations": [
		{
			"text": "Enter Lab with caution: you’re bound to fall under the spell of the bourgeois. The Instagram-worthy shop is best for a date or if you want to just look cute while writing in a journal. If you’re actually trying to get studying done, do not sit in one of the slightly mismatched chairs. But if you’re willing to give into the absurdity, get a pour over coffee and a macaroon and settle in for some of the best people watching in Ann Arbor.",
			"person": "Rebecca Lerner"
		}
	],
	"articleTitle2": "Regents approve new $75 million robotics laboratory ",
	"address": "505 E Liberty St # 300, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2796,
		"lng": -83.7427
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/lab.json
// module id = 903
// module chunks = 0